import { useEffect, useState } from "react";
import { getPresignedUrl } from "../../features/api/dts_api_wrapper";
import { useDtsAppContext } from "../provider/DtsAppContextProvider";
import { useApi, useErrorDialog } from "../../hooks";
import { useTranslation } from "react-i18next";

export const EngineLabelLocation = () => {
  //言語切替用
  const { t } = useTranslation();
  const { dacUserId } = useDtsAppContext();
  const userId =
    dacUserId ||
    localStorage.getItem(
      `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.LastAuthUser`
    ) ||
    "";

  const language = localStorage.getItem("language") ?? "";

  const { handleApi } = useApi();

  //署名付きURLを格納
  const [presignedUrl, setPresignedUrl] = useState<string>("");

  // エラーダイアログ
  const { showErrorDialog } = useErrorDialog();

  useEffect(() => {
    if (!language) {
      showErrorDialog(
        t("共通エラーポップ.エラー"),
        t("共通エラーポップ.通信エラーが発生しました。"),
        "closeTab"
      );
    } else {
      handleEngineLabelLocationInit();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, []);

  const handleEngineLabelLocationInit = async () => {
    try {
      if (!userId) {
        //何らかの理由でuserIdが読み込めなかった
        throw new Error("userId is unknown");
      }
      const getPresignedUrlResult = await handleApi(
        getPresignedUrl,
        userId,
        "0",
        "300",
        language
      );

      if (getPresignedUrlResult.presignedUrl) {
        setPresignedUrl(getPresignedUrlResult.presignedUrl);
      }
      //署名付きURLのエラー処理
      if ("errorMessage" in getPresignedUrlResult) {
        console.log("errorMessage: ", getPresignedUrlResult.errorMessage);
        throw new Error(getPresignedUrlResult.errorMessage);
      }
    } catch (err) {
      console.log("[Engine Label Location]err: ", err);
      showErrorDialog(
        t("共通エラーポップ.エラー"),
        t("共通エラーポップ.通信エラーが発生しました。"),
        "closeTab"
      ); //エラー", "通信エラーが発生しました。(タブを閉じる)
    }
  };

  return (
    <>
      <div className="flex flex-col h-svh overflow-scroll bg-white">
        <iframe
          src={presignedUrl}
          title="Engine label location"
          className="w-screen h-screen border-none"
        ></iframe>
      </div>
    </>
  );
};
